export const scrollErrorText = 'Please scroll and fill valid details in the form';
export const caseSensitiveCaptcha =  '*CAPTCHA is case-sensitive and does not have space';
export const couldNotLoadCaptcha = 'Couldn’t load CAPTCHA. Please retry'
export const residentialAddressText = 'Use residential address info for office address'
export const WHY_IS_THIS_REQUIRED = 'Why is this required?';
